const getAreaCaracteristicaLabel = (caracteristica) => {
    let response = '';

    switch (caracteristica) {
        case 'projeto':
            response = 'Projeto'
            break;
        case 'area':
            response = 'Área'
            break;
        case 'bioma':
            response = 'Bioma'
            break;
        case 'estruturaVegetacao':
            response = 'Estrutura de vegetação'
            break;
        case 'fitofisionomia':
            response = 'Fitofisionomia'
            break;
        case 'potencialRegeneracao':
            response = 'Potencial de regeneração'
            break;
        case 'caracteristicasSolo':
            response = 'Caracteristicas do solo'
            break;
        case 'fatoresDegradacao':
            response = 'Fatores de degradação'
            break;
        case 'acoesControle':
            response = 'Ações de controle'
            break;
        case 'tecnicasPlantio':
            response = 'Técnicas de plantio'
            break;
        case 'usoRecenteSolo':
            response = 'Uso mais recente do solo'
            break;
        case 'metodosRecomposicao':
            response = 'Métodos de recomposição'
            break;
        case 'justificativa':
            response = 'Justificativa'
            break;
        case 'aprovado':
            response = 'Aprovado?'
            break;
        case 'dataAprovacao':
            response = 'Data da aprovacao'
            break;
        case 'justificativa':
            response = 'Justificativa'
            break;
        case 'retificacaoSolicitada':
            response = 'Retificação solicitada'
            break;
        default:
            break;
    }

    return response;
},

AcoesControle = {
    cercas: 'Serão construídas cercas para evitar que o gado danifique a vegetação na área em recomposição.',
    aceiros: 'Serão feitos aceiros para evitar que incêndios danifiquem a vegetação na área em recomposição.',
    controleEspeciesCompetidorasDaninhas: 'Serão utilizadas técnicas de controle de espécies daninhas invasoras.',
    remocaoEspéciesExoticas: 'Serão utilizadas técnicas de corte/remoção de espécies exóticas.<strong> Aviso: Em caso de retirada de indivíduos exóticos arbóreos em áreas de APP com declividade maior do que 25°, é necessária a inserção de uma autorização da CETESB</strong>.',
    controleFormigasCortadeiras: 'Serão adotadas técnicas de controle para formigas cortadeiras e/ou cupim.',
    solotecnicasdepreparo: 'Serão realizadas técnicas de preparo e descompactação do solo para preparo da área total ou da linha de plantio. <strong> Aviso : Efetuar práticas conservacionistas de solo ao realizar as operações na APP, evitando deixar o solo exposto e desprotegido</strong>.',
    solotecnicasconservacao: 'Serão adotadas técnicas para conservação de solo.'
},

TecnicasPlantio = {
    PlantioEspeciesNativas: 'Plantio de espécies nativas em área total através do plantio de mudas, ramos, sementes, raízes ou quaisquer tipos de propágulos.',
    PlantiointercaladoNativas: 'Plantio intercalado de espécies nativas de ocorrência regional e exóticas (exceto com potencial de invasão) , em sistema agroflorestal (SAF), na Reserva Legal em no máximo, 50% da área a restaurar.',
    Plantiointercalado: 'Plantio intercalado de espécies lenhosas, perenes ou de ciclo longo, sendo nativas de ocorrência regional e exóticas (exceto pinus e eucalipto e com potencial de invasão), em APP disponível apenas quando se tratar de imóvel com área até 4 módulos fiscais e com adesão ao PRA.',
    Nucleacao: 'Nucleação.',
    PlantioEspeciesNativasconjugadoRegeneracaonatural: 'Enriquecimento com o plantio de espécies nativas, por meio de mudas, ramos, sementes, raízes ou quaisquer tipos de propágulos, conjugado com a condução da regeneração natural de espécies nativas.'
},

MetodosRecomposicao = {
    APPRLpotencialRegeneracaoNatura_RegeneracaoNaturalEspeciesNativas: '(Para APP ou RL) Condução da regeneração natural das espécies nativas.',
    APPRLpotencialRegeneracaoNatura_plantarEspeciesNativasRegionaisMudasSementesEstacas: '(Para APP ou RL) Condução da regeneração natural de espécies nativas conjugado com o plantio de espécies nativas regionais.',
    APPRLnaoApresentaPotencialRegeneracao_PlantioEspeciesNativasAreaTotal: '(Para APP ou RL) Plantio de espécies nativas regionais em área total.',
    RLApresentaPotencialRegeneracao_RegeneracaoNaturalEspeciesNativasPlantioParcialIntercalandoEspeciesLenhosas: '(Para RL) Plantio intercalado de espécies nativas de ocorrência regional e exóticas (exceto com potencial de invasão), em sistema agroflorestal, sendo que a área recomposta com espécies exóticas não poderá exceder a 50% (cinquenta por cento) da área total a ser recuperada conjugado com condução da regeneração natural.',
    RLnaoApresentaPotencialRegeneracao_PlantioAreaTotalIntercalandoEspeciesLenhosasPerene: '(Para RL) Plantio intercalado de espécies nativas de ocorrência regional e exóticas (exceto com potencial de invasão), em sistema agroflorestal, sendo que a área recomposta com espécies exóticas não poderá exceder a 50% (cinquenta por cento) da área total a ser recuperada.',
    APPApresentaPotencialRegeneracao_PlantioAreaTotalIntercalandoEspeciesLenhosasPerene: '(Para APP em imóveis com área de até 4 módulos fiscais) Plantio intercalado de espécies lenhosas, perenes ou de ciclo longo, sendo nativas de ocorrência regional e exóticas (exceto pinus, eucaliptos e com potencial de invasão), em até 50% da área total a ser recomposta conjugado com a condução da regeneração natural.',
    APPnaoApresentaPotencialRegeneracao_PlantioAreaTotalIntercalandoEspeciesLenhosasPerene: '(Para APP em imóveis com área de até 4 módulos fiscais) Plantio intercalado de espécies lenhosas, perenes ou de ciclo longo, sendo nativas de ocorrência regional e exóticas (exceto pinus, eucaliptos e com potencial de invasão), em até 50% da área total a ser recomposta.',
},

UsoMaisRecenteSolo = {
    Agricultura: 'Agricultura',
    Pastagem: 'Pastagem',
    Mineração: 'Mineração',
    Emrecomposição: 'Em recomposição',
    Silvicultura: 'Silvicultura',
    Outro: 'Outro'
}

export {
    getAreaCaracteristicaLabel,
    AcoesControle,
    TecnicasPlantio,
    MetodosRecomposicao,
    UsoMaisRecenteSolo
};
